import pickupRequestManagementComponent from './pickup_request_management.component'

let pickupRequestManagementModule = angular
.module('pickupRequestManagement', [])
.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $urlRouterProvider.otherwise('/pickup-request-management');

  $stateProvider
    .state('pickupRequestManagement', {
      url: '/v2/index.html#/pickup-request-management',
      component: 'pickupRequestManagement',
      data: {
        requireLogin: true,
        requireACL: 'pickup_request_management.view'
      },
    });
})
.component('pickupRequestManagement', pickupRequestManagementComponent).name

export default pickupRequestManagementModule;



// WEBPACK FOOTER //
// ./client/app/components/pickup_request_management/index.js